// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticlesBlock_root__zJ5G7"};